<template>
    <l-marker 
        v-if="$route.params.mapUser != undefined"
        :lat-lng="[$route.params.mapUser.adresse.lat, $route.params.mapUser.adresse.lng]"
        :zIndexOffset="1502"
        :options="{riseOnHover: true, riseOffset: 3000}"
    >
        <l-icon 
            :icon-url="require('../assets/map/cluster.svg')" 
            :icon-size="[40, 40]" />
        <l-popup>
            <b-button 
                variant="secondary"
                @click="$router.push({ path: '/nachrichten', query: { uid: $route.params.mapUser.id }})"
                block
            >
                {{$route.params.mapUser.firstName}} {{$route.params.mapUser.lastName}}
                <img src="../assets/interface/edit.svg" 
                    style="filter:invert(1);padding-left:3px;padding-bottom:3px" 
                    height="27em" width="27" 
                />
            </b-button>
        </l-popup>
    </l-marker>
</template>

<script>
import { LMarker, LIcon, LPopup } from 'vue2-leaflet'
export default {
    name: "UebersichtMarkerFocus",
    components: {
        LMarker,
        LIcon,
        LPopup
    }
}
</script>